import React, { createContext, useContext, useReducer, Dispatch } from 'react'
import { CountryType, CurrencyType, DestinationType } from '../models'

const initialState = {
  countries: [],
  destinations: [],
  currencies: [],
}

export type VocabularyType = {
  countries: CountryType[]
  destinations: DestinationType[]
  currencies: CurrencyType[]
}

type VocabularyContextType = {
  vocabulary: VocabularyType
  dispatchVocabulary: Dispatch<any>
}

const vocabularyReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'initial_state':
      return {
        ...initialState,
      }
    case 'load_countries':
      return {
        ...state,
        countries: action.payload.countries,
      }
    case 'load_destinations':
      return {
        ...state,
        destinations: action.payload.destinations,
      }
    case 'load_currencies':
      return {
        ...state,
        currencies: action.payload.currencies,
      }
    default:
      return state
  }
}

export const VocabularyContext = createContext<VocabularyContextType>({
  vocabulary: initialState,
  dispatchVocabulary: () => null,
})

export interface VocabularyContextProps {
  children: React.ReactElement
}

export default ({ children }: VocabularyContextProps) => {
  const [vocabulary, dispatchVocabulary] = useReducer(
    vocabularyReducer,
    initialState
  )
  return (
    <VocabularyContext.Provider
      value={{
        vocabulary,
        dispatchVocabulary,
      }}
    >
      {children}
    </VocabularyContext.Provider>
  )
}

export const useVocabulary = () => useContext(VocabularyContext)
